import React from "react";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { getCronBuilderSx } from "../theme/panelStyles";

const CronBuilderBox = ({ children, sx = {} }) => {
  const theme = useTheme();

  return <Box sx={{ ...getCronBuilderSx(theme), ...sx }}>{children}</Box>;
};

export default CronBuilderBox;
